import { useEditor } from "@smartfire/js-block-engine";
import { EditableImg } from "@smartfire/components";
import style from "./style.module.scss";
import clsx from "clsx";

function Media({ imageProp, link, icon }) {
  const { isEditing } = useEditor();

  const Wrapper = link && !isEditing ? "a" : "div";

  return (
    <Wrapper
      href={link && !isEditing ? link : undefined}
      className={clsx(style.block, isEditing && style.isEditing)}
      target="_blank"
    >
      {icon && <span className={style.logo}>{icon}</span>}
      <EditableImg smartProp={imageProp} />
    </Wrapper>
  );
}

export default Media;
